import { documentsService } from 'hq/services';
import { useMutation, useQueryClient } from 'react-query';
import { QUERY_KEYS } from 'api/query-keys';
import { EditDocumentData } from 'hq/services/documents-service.types';

export const useEditDocument = () => {
  const mutationFn = async (formData: EditDocumentData) => {
    return await documentsService.editDocument(formData);
  };

  const queryClient = useQueryClient();

  return useMutation(mutationFn, {
    onSuccess: () => {
      queryClient.invalidateQueries(QUERY_KEYS.documents());
    },
  });
};
